import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpClient } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { BrowserCookieStorage } from '@core/_services/browser-cookie.storage';

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {
  constructor(private storage: BrowserCookieStorage, private http: HttpClient) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(async (event) => {
        if (event instanceof HttpResponse) {
          const header = event.headers.get('Authorization');

          if (header) {
            const token = header.split(' ')[1];
            this.storage.setItem('Authorization', token);
            await this.setQlikCookie(token);
          }
        }
      }),
    );
  }

  private async setQlikCookie(token: string): Promise<any> {
    return this.http
      .get('https://qlikcorp.vipservice.ru/jwt/single/?appid=323506c7-fe2f-4d91-a94c-ec8d5e496485', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        observe: 'response',
        responseType: 'text',
        withCredentials: true,
      })
      .pipe(
        catchError((err) => {
          console.log(err);
          return of(err);
        }),
      )
      .toPromise();
  }
}
